// Pure matching used by the "does this company already exist?" check (see existingCompanies.ts for the database query).
export interface ExistingCompany { id: string; code: string; name: string; is_active: boolean }

// Same idea as the BoxTop name matching: upper-case, punctuation to spaces, legal-form words dropped.
const LEGAL = /\b(LTD|LIMITED|CO|COMPANY|CORP|CORPORATION|INC|LLC|LLP|PLC|GMBH|SA|SRL|BV|GONGSI)\b/g
export const normalizeForMatch = (s: string): string =>
  (s || '').toUpperCase().replace(/[^A-Z0-9\s]/g, ' ').replace(LEGAL, ' ').replace(/\s+/g, ' ').trim()
const squash = (s: string): string => (s || '').toUpperCase().replace(/[^A-Z0-9]/g, '')

// Pure: which of `rows` look like the company being typed. Deliberately generous (a short name such as LANDR must find
// "LANDR FREIGHT FORWARDING LIMITED"), but only on whole words, so "SHENZHEN ABC" does not match "SHENZHEN XYZ".
export function rankExisting(typedName: string, typedCode: string | null | undefined, rows: ExistingCompany[]): ExistingCompany[] {
  const n = normalizeForMatch(typedName)
  const codeSq = squash(typedCode ?? '')
  const nameSq = squash(typedName)
  const out: ExistingCompany[] = []
  for (const r of rows) {
    const rn = normalizeForMatch(r.name)
    const rcode = squash(r.code)
    const sameCode = rcode !== '' && (rcode === codeSq || rcode === nameSq)
    const sameWords = n !== '' && rn !== '' && (
      rn === n || (' ' + rn + ' ').includes(' ' + n + ' ') || (' ' + n + ' ').includes(' ' + rn + ' '))
    if (sameCode || sameWords) out.push(r)
  }
  return out.sort((a, b) => Number(b.is_active) - Number(a.is_active) || a.name.localeCompare(b.name))
}

